export default {
  data() {
    return {
      menuTree: this.$router.options.routes,
    };
  },

  mounted() { },

  methods: {
    calcIndent(layer) {
      return 'padding-left:' + layer * 24 + "px;";
    },

    iconSize(/*layer*/) {
      //return 24 - layer*2;
      return 20;
    },

    getFoundation(node) {
      var foundation = null
      node.children.forEach(childnode => {
        if (childnode.foundation) {
          foundation = childnode;
        }
      });
      return foundation;
    },

    findNodeByRouteName(name) {
      return this.$router.resolve({ name })
    },
  },

  computed: {
    showNav() {
      if (this.isPadBool) {
        return this.$store.getters['navstore/Extended'];
      }
      else {
        return true;
      }
    },

    headerHasSubmenu: {
      get() {
        return this.$store.getters['navstore/HeaderHasSubmenu'];
      },
      set(udate) {
        //console.log('set headerHasSubmenu', udate);
        this.$store.dispatch('navstore/setHeaderHasSubmenu', udate);
      }
    },

    onlyIconMode() {
      if (!this.isPadBool) {
        return !this.$store.getters['navstore/Extended'];
      }
      else {
        return false;
      }
    },

    activeColor() {
      if (this.isActive) {
        return "primary";
      }
      else if (this.isActiveParent) {
        return "#2E567C";
      }
      else {
        return false;
      }
    },

    iconColor() {
      if (this.activeColor) {
        return this.activeColor;
      } else {
        return '';
      }
    },

    textColorClass() {
      if (this.activeColor) {
        return this.activeColor + '--text';
      } else {
        return 'useThemeTextColor';
      }
    },
  }
}